import { SalesFormat } from '../../types';

export const initialSaleFormat = (
  increaseAmount,
  valueThatRemoveTheIncreaseAmountTag,
) =>
  increaseAmount === valueThatRemoveTheIncreaseAmountTag
    ? SalesFormat.UNIDADE
    : SalesFormat.CAIXA;
